<template>
    <div>
      <span>{{params.value}} &nbsp;({{params.data.currencyCode}}) </span>
    </div>
</template>

<script>
export default {
  name: 'CellRendererPrice',
}
</script>
